export const Create_Table = "Create_Table";
export const Join_To_Table = "Join_To_Table";
export const Leave_From_Table = "Leave_From_Table";
export const Delete_Table = "Delete_Table";
export const Table_Error = "Table_Error";
export const Get_Tables = "Get_Tables";
export const Get_Table = "Get_Table";
export const Set_Player = "Set_Player";
